module.exports = __webpack_public_path__ + "public/tier-up-anim-sparkles.png";